export { InvestInAPropertyTableSection } from './InvestInAPropertyTableSection';
export { propertiesData } from './propertiesData';
export { getPropertiesByVariant } from './getPropertiesByVariant';
export * from './types';
